import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskLines({ lines, as: Tag = "h1", className = "", lineClassName = "", delay = 0, stagger = 0.12 }) {
  const reduce = useReducedMotion();
  return (
    <Tag className={className}>
      {lines.map((line, i) => {
        const node = typeof line === "string" ? line : line.node;
        return (
          <span key={i} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
            <motion.span
              className={`block will-change-transform ${lineClassName}`}
              initial={reduce ? { opacity: 0 } : { y: "112%" }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: reduce ? 0.4 : 1.05, ease: EASE, delay: delay + i * stagger }}
            >
              {node}
            </motion.span>
          </span>
        );
      })}
    </Tag>
  );
}

export function FadeUp({ children, delay = 0, y = 28, className = "", amount = 0.15 }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
